import { DC_PARTS } from "@/lib/dataCenterParts";

export const DataCenterDiagram = ({ active }) => {
  const part = DC_PARTS.find((item) => item.id === active);
  return (
    <div className="dc-photo relative overflow-hidden bg-white" style={{ "--spot-x": `${part.pin.x}%`, "--spot-y": `${part.pin.y}%`, "--spot-r": `${part.spot}%` }}>
      <img src="/dc-cutaway.webp" alt="Cutaway render of a modern data center with a DCYB sign on the front wall: server halls in the middle, transformers, generators and batteries on the left, rooftop chillers above and fiber conduits on the right" width="1264" height="848" loading="lazy" className="block w-full h-auto select-none" draggable="false" />
      <div aria-hidden="true" className="dc-spotlight absolute inset-0 pointer-events-none" />
      <span aria-hidden="true" className="dc-ring absolute pointer-events-none" style={{ left: `${part.pin.x}%`, top: `${part.pin.y}%` }} />
    </div>
  );
};
